<template>
  <div>
    <div class="main-view">
      <HearderView id="m-header" />


      <div id="banner" class="banner">
        <div>
          <Swiper ref="bannerSwiper" :modules="modules" :loop="true" :effect="'fade'" navigation
            :pagination="{ clickable: true }" :autoplay="{ delay: 4000, disableOnInteraction: false }">
            >
            <SwiperSlide v-for="(item, index) in getSwiperImgs()" :key="index">
              <div :style="item"></div>
            </SwiperSlide>
          </Swiper>
        </div>
        <div style="display: flex;margin-top: 10px;position: absolute;bottom:30px;right:20px;z-index: 99;">
          <div class="footer_copyRight">
            <a class="icpblock" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2024323580号-1</a>
          </div>
          <div class="footer_copyRight" style="margin-left: 8px;">
            <img class="govlogo" alt="" src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png" />
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002004956" rel="noreferrer"
              target="_blank">粤公网安备44030002004956号</a>
          </div>
        </div>
      </div>
      <div id="m-banner" class="m-banner">
        <div>
          <Swiper ref="mBannerSwiper" :modules="modules" :loop="true" :effect="'fade'" navigation
            :pagination="{ clickable: true }" :autoplay="{ delay: 4000, disableOnInteraction: false }">
            >
            <SwiperSlide v-for="(item, index) in mSwiperImgs" :key="index">
              <div :style="item"></div>
            </SwiperSlide>
          </Swiper>
        </div>
        <div style="margin-top: 10px;position: absolute;bottom:30px;right:50%;z-index: 99;    right: 20px;
    text-align: right;">
          <div class="footer_copyRight">
            <a class="icpblock" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2024323580号-1</a>
          </div>
          <div class="footer_copyRight" style="margin-left: 8px;">
            <img class="govlogo" alt="" src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png" />
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002004956" rel="noreferrer"
              target="_blank">粤公网安备44030002004956号</a>
          </div>
        </div>
      </div>
      <HearderView id="header" />

    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { EffectFade, Autoplay } from 'swiper/modules';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
// Import Swiper styles
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import HearderView from '@/components/HeaderView.vue'

export default {
  name: 'MainViewIndex',
  components: {
    Swiper,
    SwiperSlide,
    HearderView,
  },
  data() {
    return {
      mSwiperImgs: [],
      modules: [EffectFade, Autoplay, Navigation, Pagination, Scrollbar, A11y],
      // bannerList: [
      //   require('@/assets/home-swiper1.jpg'),
      //   require('@/assets/home-swiper2.jpg')
      // ]
      // ,
      isHoverHeader: false,
      parentStyle: {
        'background-image': 'http://nas.kingbox999.com/file/jpg/7676a985cba31838e8c3e6fd6baf8f38.jpg',
        'background-repeat': 'no-repeat',
        'background-position': 'center center',
        'background-size': 'cover',
        'width': '100vw',
        'height': '100vh'
      },
      itemService: ['经营品类', '品牌服务', '会员专区', '关于我们', '加入我们', '联系我们'],

    }
  },
  created() {
    document.documentElement.style.setProperty('--swiper-theme-color', '#ffffff');
    this.getmSwiperImgs()
  },
  methods: {
    async getmSwiperImgs() {
      try {
        const response = await fetch('http://wxa.kingbox999.com/www/support/getBanner', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            device: 'm',
          }),
        });
        const data = await response.json();
        this.mSwiperImgs = data.data
      } catch (error) {
        // console.error(error);
      }
    },
    getSwiperImgs() {
      const ary = {
        'background-image': 'url(http://nas.kingbox999.com/file/jpg/7676a985cba31838e8c3e6fd6baf8f38.jpg)',
        'background-repeat': 'no-repeat',
        'background-position': 'center center',
        'background-size': 'cover',
        'width': '100vw',
        'height': '100vh'
      }
      const ary2 = {
        'background-image': 'url(http://nas.kingbox999.com/file/jpg/46eed06cea851b7b39d4bab5237fe8b0.jpg)',
        'background-repeat': 'no-repeat',
        'background-position': 'center center',
        'background-size': 'cover',
        'width': '100vw',
        'height': '100vh'
      }
      const ary3 = {
        'background-image': 'url(http://nas.kingbox999.com/file/jpg/d5703880ba683705acc4c11a455e0064.jpg)',
        'background-repeat': 'no-repeat',
        'background-position': 'center center',
        'background-size': 'cover',
        'width': '100vw',
        'height': '100vh'
      }
      const ary4 = {
        'background-image': 'url(http://nas.kingbox999.com/file/jpg/8437a6ff6e9b27699f6bed8e08177909.jpg)',
        'background-repeat': 'no-repeat',
        'background-position': 'center center',
        'background-size': 'cover',
        'width': '100vw',
        'height': '100vh'
      }
      return { ary, ary2, ary3, ary4 }
    }
  }
  // 其他组件选项...
}
</script>
<style scoped>
/*手机端*/
@media screen and (max-width: 767px) {
  #banner {
    display: none;
    overflow: hidden;

  }

  #header {
    display: none;
    overflow: hidden;
  }

}

/* 电脑端样式，当视口宽度大于等于 768px 时应用 */
@media screen and (min-width: 768px) {
  #m-banner {
    display: none;
    overflow: hidden;
  }

  #m-header {
    display: none;
    overflow: hidden;
  }
}

.swiper-button-prev {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E");
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  background-size: 100% 100%;
  width: 50px;
  height: 50px;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all .5s;
  opacity: .5;
  z-index: 999;
  display: block;
  position: absolute;
}

.swiper-button-next {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E");
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  background-size: 100% 100%;
  width: 50px;
  height: 50px;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all .5s;
  opacity: .5;
  z-index: 999;
  display: block;
  position: absolute;
}

.banner {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  overflow: hidden;
}

.banner-img {
  object-fit: contain;
  width: 100%;
  height: 100%;

}

.footer_copyRight a {
  color: #ffffff;
  text-decoration: none;
  margin-left: 3px;
  font-size: 12px;
}


.govlogo {
  height: 15px;
}
</style>